<template>
  <div class="swiper-card card-notifications">
    <div class="corner-radius-blur"></div>
    <div class="notifications-content">
      <div class="icon" :key="'icon'">
        <svg width="169" height="150" viewBox="0 0 169 150" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M114.594 0.0878915C124.072 1.05469 131.467 9.05273 131.467 18.75V131.25C131.467 140.947 124.072 148.945 114.594 149.912L112.686 150H56.3431L54.4357 149.912C44.9571 148.945 37.5621 140.947 37.5621 131.25V18.75C37.5621 9.05273 44.9571 1.05469 54.4357 0.0878915L56.3431 0H112.686L114.594 0.0878915ZM56.3431 14.0625C53.7607 14.0625 51.6479 16.1719 51.6479 18.75V131.25C51.6479 133.828 53.7607 135.938 56.3431 135.938H112.686C115.269 135.938 117.381 133.828 117.381 131.25V18.75C117.381 16.1719 115.269 14.0625 112.686 14.0625H56.3431ZM96.2528 107.812C100.156 107.812 103.296 110.947 103.296 114.844C103.296 118.74 100.156 121.875 96.2528 121.875H72.7765C68.8736 121.875 65.7336 118.74 65.7336 114.844C65.7336 110.947 68.8736 107.812 72.7765 107.812H96.2528ZM14.3205 39.082C17.079 36.8262 21.158 37.002 23.7404 39.5801C26.4989 42.334 26.4989 46.7871 23.7404 49.5117L14.6433 58.5938L22.0971 66.0352L22.9481 66.9727C24.7968 69.2285 25.8239 72.0703 25.8239 75C25.8239 78.3691 24.474 81.5918 22.0971 83.9648L14.6433 91.4062L23.7404 100.488L24.2393 101.016C26.4989 103.77 26.3228 107.842 23.7404 110.42C21.158 112.998 17.079 113.145 14.3205 110.918L13.7923 110.449L3.72686 100.371C1.64334 98.291 0.352145 95.5664 0.058691 92.666L0 91.4062L0.058691 90.1465C0.352145 87.2461 1.64334 84.5215 3.72686 82.4414L11.1806 75L3.72686 67.5586C1.64334 65.4785 0.352145 62.7539 0.058691 59.8535L0 58.5938L0.058691 57.334C0.352145 54.4336 1.64334 51.709 3.72686 49.6289L13.7923 39.5508L14.3205 39.082ZM145.26 39.5508C147.842 36.9727 151.921 36.8262 154.679 39.0527L155.208 39.5508L165.273 49.5996C167.357 51.6797 168.648 54.4043 168.941 57.3047L169 58.5645L168.941 59.8242C168.648 62.7246 167.357 65.4492 165.273 67.5293L157.819 74.9707L165.273 82.4121C167.357 84.4922 168.648 87.2168 168.941 90.1172L169 91.377L168.941 92.6367C168.648 95.5371 167.357 98.2617 165.273 100.342L155.208 110.391L154.679 110.889C151.921 113.145 147.842 112.969 145.26 110.391C142.677 107.812 142.53 103.74 144.761 100.986L145.26 100.459L154.357 91.377L146.903 83.9355C144.526 81.5625 143.176 78.3398 143.176 74.9707C143.176 72.041 144.203 69.1992 146.052 66.9434L146.903 66.0059L154.357 58.5645L145.26 49.4824C142.501 46.7285 142.501 42.2754 145.26 39.5508Z" fill="black"/>
        </svg>
      </div>
      
      <h3 :key="'title-wrapper'">{{ slide.content.title }}</h3>

      <p :key="'byline-wrapper'" v-if="!hasNotifications">{{ slide.content.byline }}</p>
      <button v-if="!hasNotifications" :key="'notifications'" @click="enableNotifications()">Enable notifications</button>

      <p :key="'byline-intro'" v-if="hasNotifications">
        You're all set! We'll keep you updated so you never miss another story.
      </p>

      <div class="meta-block">
        <MetaBlock :items="getMetaItems" />
      </div>
    </div>
  </div>
</template>

<script>
  // import Lottie from '@/components/v5/Lottie.vue';
  import MetaBlock from '@/components/v5/elements/MetaBlock.vue';

  export default {
    data() {
      return {
        reveal: false
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    components: {
      // Lottie,
      MetaBlock
    },

    computed: {
      hasNotifications() {
        return false;
        // return this.$userEngine.hasNotifications;
      },

      getMetaItems() {
        return [
          {
            icon: 'meta-book',
            content: 'News you should<br>know about',
          },
          {
            icon: 'meta-relax',
            content: 'Stay on track<br>with healthy news',
          }
        ]
      }
    },

    mounted () {
      this.$watch('$route.params.stack', (slug) => {
        if (slug === this.slide.slug) {
          this.$emit('swiperUpdate');
          this.$emit('enableNextAction');
          setTimeout(() => {
            this.play();
          }, 500);
        }
      }, { immediate: true });

      this.EventBus.$on('stack:notifications', () => {
        this.next();
      });
    },

    methods: {
      play() {
        this.reveal = true;
        
        // setTimeout(() => {
        //   this.$refs.lottie?.play();
        // }, 50);
      },

      enableNotifications() {
        this.EventBus.$emit("appCallback", {
          type: 'notificationsCallback',
          data: {}
        });

        this.EventBus.$emit('track:event', {
          label: 'StackFlow: Notifications',
          once: true,
        });
      },

      next() {
        this.$emit('next');
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-notifications {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: 550px;
    margin: 0 auto;
    text-align: left;
    padding-top: 2rem;
    z-index: 10;

    .lottie {
      margin-bottom: -4rem;
    }

    .notifications-content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      z-index: 10;
    }

    .icon {
      margin-bottom: 2rem;

      svg {
        height: 50px;
        width: 50px;

        path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }
      }
    }

    h3 {
      font-family: 'Brawler';
      font-size: 50px;
      line-height: 100%;
      font-weight: normal;
      text-wrap: balance;
      margin-bottom: 1.8rem;

      .callout {
        color: $yellow-tone-4;

        .darkmode & {
          color: $yellow-tone-3;
        }
      }

      .desktop & {
        font-size: 70px;
      }
    }

    p {
      font-size: 20px;
      line-height: 150%;
      text-wrap: balance;
    }

    button {
      margin-top: 2rem;
      height: 55px;
      border-radius: 10px;
      font-size: 1rem;
      padding-top: 0.8rem;
    }
  }

  .meta-block {
    z-index: 10;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    margin-top: 2rem;
    // jim's hack
    // position: absolute;
    // bottom: 4.5rem;
    // width: 90vw;
    // left: 1rem;
    // right: 1rem;
  }

  .reveal-group {
    position: relative;
    z-index: 10;
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.25s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.40s;
  }
</style>

<style lang="scss">
.fade-slide-bottom-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-bottom-enter {
  opacity: 0;
  transform: translateY(50px);
}
.fade-slide-bottom-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>